import { render, staticRenderFns } from "./DResponsive.vue?vue&type=template&id=1b01d62e&scoped=true&"
import script from "./DResponsive.vue?vue&type=script&lang=js&"
export * from "./DResponsive.vue?vue&type=script&lang=js&"
import style0 from "./DResponsive.vue?vue&type=style&index=0&id=1b01d62e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01d62e",
  null
  
)

export default component.exports